import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  Input,
  input,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import {
  DogBreed,
  DogBreedService,
} from '../../../core/services/dog-breed-service';
import { BaseComponent } from '../../component-base';

@Component({
  selector: 'app-dog-breed-picker',
  templateUrl: './dog-breed-picker.component.html',
  styleUrl: './dog-breed-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DogBreedPickerComponent extends BaseComponent implements OnInit {
  @ViewChild('dogBreedInput') dogBreedInput:
    | ElementRef<HTMLInputElement>
    | undefined;

  @Input() hideRequiredMarker = true;

  dogBreedService = inject(DogBreedService);

  formGroup = input.required<FormGroup>();
  formKey = input.required<string>();

  dogBreeds: (DogBreed & { id: number })[] = [];
  filteredDogBreeds = signal<(DogBreed & { id?: number })[]>([]);

  loaded = signal(false);
  public langKey: 'hu' | 'en' = 'en';
  constructor(
    private translate: TranslateService,
    private ref: ChangeDetectorRef
  ) {
    super();
  }

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.langKey = this.currentLang() == 'hu' ? 'hu' : 'en';
    const newDogBreedsRequest$ = this.dogBreedService.getNewDogBreeds();
    const dogBreedTranslationsRequest$ = this.dogBreedService.getDogBreeds();

    forkJoin([newDogBreedsRequest$, dogBreedTranslationsRequest$]).subscribe(
      res => {
        const breeds = res[0].map(db => ({
          id: db.id,
          ...(res[1].find(i => i.en === db.name) ?? {}),
        }));
        this.dogBreeds = breeds;
        this.filteredDogBreeds.set(breeds);
        // this.dogBreeds = { ...res[1] };
        // this.filteredDogBreeds.set(res[1]);
        // this.loaded.set(true);

        this.loaded.set(true);
      }
    );
  }

  protected override langChangeCallback(): void {
    this.langKey = this.currentLang() == 'hu' ? 'hu' : 'en';

    // this can trigger the displayWidth/displayFn to recalculate its showed value
    this.formGroup().controls[this.formKey()].setValue(this.formGroup().controls[this.formKey()].value, { emitEvent: false })
  }

  filterDogBreeds(): void {
    const val = this.dogBreedInput?.nativeElement.value || '';
    const dogBreeds = this.dogBreedFilter(val);
    this.filteredDogBreeds.set(dogBreeds);
  }

  private dogBreedFilter(filterString: string): DogBreed[] {
    let filteredList = [];
    if (this.translate.currentLang === 'hu') {
      filteredList = this.dogBreeds.filter(db =>
        db.hu?.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())
      );
      filteredList = filteredList.sort((a, b) =>
        (a.hu || '').localeCompare(b.hu || '')
      );
    } else {
      filteredList = this.dogBreeds.filter(db =>
        db.en?.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())
      );
      filteredList = filteredList.sort((a, b) =>
        (a.en || '').localeCompare(b.en || '')
      );
    }
    return filteredList;
  }

  public displayFn = (id: number) => {
    if (id === null || id === undefined) return '';

    const dogBreed: any = this.dogBreeds.find(db => db.id === id);

    return dogBreed?.[this.langKey];
  };

  public detectChanges() {
    this.ref.detectChanges();
  }
}
